import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
// import { FormsModule } from '@angular/forms';
// import { CustomerComponent } from './customer.component';
// import { NewItemDirective } from './new-item.directive';
// import { OrdersPipe } from './orders.pipe';

@NgModule({
 imports: [
    NgbModule.forRoot(),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
  ],
  exports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})

export class SharedLibrariesModule { }



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared-libraries.module.ts